import React, { useContext, useEffect, useState } from "react";
import { GlobalContext } from "../../../../contexts/GlobalContext";
import { getDataNotificationProcess } from "../../../../hooks/api/apiDebug";
import { getAvailablePlugins } from "../../../../hooks/api/general";
import DataNotificationProcess from "./DataNotificationProcess";
import './apiDebug.css';

export default function ViewNotificationProcessDebug() {
  const globalContext = useContext(GlobalContext);
  const [inputPlugin, setInputPlugin] = useState("");
  const [inputOrderId, setInputOrderId] = useState("");
  const [inputRoute, setInputRoute] = useState("");
  const [inputProductId, setInputProductId] = useState("");
  const [plugins, setPlugins] = useState([]);
  const [loadingPlugins, setLoadingPlugins] = useState(false);
  const [apiData, setApiData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [hasSearched, setHasSearched] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPage, setTotalPage] = useState(null);
  const [totalRecords, setTotalRecords] = useState(0);
  const [error, setError] = useState(null);

  const fetchData = async (page = 1) => {
    if (!inputPlugin.trim()) {
      setError("Selecciona un plugin para buscar. Puedes combinarlo con order ID, route o product ID.");
      setHasSearched(false);
      return;
    }

    setApiData([]);
    setLoading(true);
    setError(null);
    setHasSearched(true);

    const params = {
      page,
      limit: 10,
    };

    if (inputOrderId.trim()) {
      params.orderId = inputOrderId.trim();
    }

    if (inputRoute.trim()) {
      params.route = inputRoute.trim();
    }

    if (inputProductId.trim()) {
      params.productId = inputProductId.trim();
    }

    try {
      const response = await getDataNotificationProcess(inputPlugin, params);
      // Expected response shape: { statusCode, message, data: { notifications: [...] } }
      const newData = response.data?.data?.notifications || response.data?.notifications || [];
      const total = response.data?.data?.total || newData.length || 0;
      const totalPages = total > 0 ? Math.ceil(total / params.limit) : 0;
      
      setTotalPage(totalPages);
      setTotalRecords(total);
      setApiData(newData);
    } catch (error) {
      console.error("API error:", error);
      setError(error.response?.data?.message || "Error al obtener los datos. Verifica el plugin y los filtros ingresados.");
      setApiData([]);
    } finally {
      setLoading(false);
    }
  };

  const handlePagination = (direction) => {
    if (!totalPage || totalPage < 1) return;

    let nextPage = currentPage;
    if (direction === "back") {
      nextPage = Math.max(1, currentPage - 1);
    } else {
      nextPage = Math.min(totalPage, currentPage + 1);
    }

    setCurrentPage(nextPage);
    fetchData(nextPage);
  };

  const handleSearch = () => {
    setCurrentPage(1);
    fetchData(1);
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleSearch();
    }
  };

  useEffect(() => {
    // fetchData(currentPage);
  }, [globalContext.currentEnterpriseId]);

  useEffect(() => {
    const loadPlugins = async () => {
      if (!globalContext?.currentEnterpriseId) return;

      setLoadingPlugins(true);
      try {
        const response = await getAvailablePlugins(globalContext.currentEnterpriseId);
        // Handle different response structures
        const pluginsData = response.data?.data || response.data || [];
        setPlugins(pluginsData);
      } catch (error) {
        console.error("Error loading plugins:", error);
        setError("Error al cargar la lista de plugins disponibles");
      } finally {
        setLoadingPlugins(false);
      }
    };

    loadPlugins();
  }, [globalContext?.currentEnterpriseId]);

  useEffect(() => {
    setHasSearched(false);
  }, [inputPlugin, inputOrderId, inputRoute, inputProductId]);

  return (
    <div className="cron-debug-container">
      <div className="cron-debug-header">
        <h1 className="cron-debug-title">
          Consultas para <strong>Notification Process</strong>
        </h1>
        <p className="cron-debug-subtitle">
          Selecciona un <strong>PLUGIN</strong> (obligatorio) y, si lo necesitas, agrega <strong>ORDER ID</strong>, <strong>ROUTE</strong> o <strong>PRODUCT ID</strong> para consultar registros del notification process
        </p>
      </div>

      <div className="cron-debug-search-section">
        <div className="search-container">
          <div className="search-input-group">
            <label htmlFor="plugin-select" className="search-label">
              PLUGIN
            </label>
            <select
              id="plugin-select"
              className="search-input"
              value={inputPlugin}
              onChange={(e) => setInputPlugin(e.target.value)}
              disabled={loading || loadingPlugins}
              style={{ 
                padding: '14px 12px',
                borderRadius: '4px',
                border: '2px solid #ddd',
                fontSize: '14px',
                backgroundColor: '#fff',
                cursor: loading || loadingPlugins ? 'not-allowed' : 'pointer',
                width: 200
              }}
            >
              <option value="">Seleccione un plugin</option>
              {plugins.map((plugin) => {
                const pluginValue =  plugin.id;
                const pluginLabel = typeof plugin === 'string' ? plugin : (plugin.label || plugin.name || plugin.value || plugin._id || plugin.id);
                return (
                  <option key={pluginValue} value={pluginValue} className="py-8">
                    {pluginLabel}
                  </option>
                );
              })}
            </select>
          </div>
          <div className="search-input-group">
            <label htmlFor="orderId-input" className="search-label">
              ORDER ID
            </label>
            <input
              id="orderId-input"
              className="search-input"
              type="text"
              value={inputOrderId}
              onChange={(e) => setInputOrderId(e.target.value)}
              onKeyPress={handleKeyPress}
              placeholder="Ej: 2000010857873356"
              disabled={loading}
            />
          </div>
          <div className="search-input-group">
            <label htmlFor="route-input" className="search-label">
              ROUTE
            </label>
            <input
              id="route-input"
              className="search-input"
              type="text"
              value={inputRoute}
              onChange={(e) => setInputRoute(e.target.value)}
              onKeyPress={handleKeyPress}
              placeholder="Ej: /stock3"
              disabled={loading}
              style={{maxWidth: '195px'}}
            />
          </div>
          <div className="search-input-group">
            <label htmlFor="productId-input" className="search-label">
              PRODUCT ID
            </label>
            <input
              id="productId-input"
              className="search-input"
              type="text"
              value={inputProductId}
              onChange={(e) => setInputProductId(e.target.value)}
              onKeyPress={handleKeyPress}
              placeholder="Ej: 123456"
              disabled={loading}
            />
          </div>
          <button
            className="search-button"
            onClick={handleSearch}
            disabled={loading || !inputPlugin.trim()}
            style={{
              fontSize: '15px',
              padding: '14px 30px',
            }}
          >
            {loading ? 'Buscando...' : 'Buscar'}
          </button>
        </div>

        {/* Pagination information */}
        {totalRecords > 0 && (
          <div className="pagination-info">
            <span>
              Mostrando página <strong>{currentPage}</strong> de <strong>{totalPage}</strong>
            </span>
            <span className="total-registros">
              Total: <strong>{totalRecords}</strong> registro{totalRecords !== 1 ? 's' : ''}
            </span>
          </div>
        )}

        {/* Pagination controls */}
        {totalPage > 1 && (
          <div className="pagination-controls">
            <button
              className="pagination-btn"
              onClick={() => handlePagination("back")}
              disabled={currentPage === 1 || loading}
            >
              ← Anterior
            </button>
            <span className="pagination-indicator">
              {currentPage} / {totalPage}
            </span>
            <button
              className="pagination-btn"
              onClick={() => handlePagination("next")}
              disabled={currentPage >= totalPage || loading}
            >
              Siguiente →
            </button>
          </div>
        )}
      </div>

      {/* Error messages */}
      {error && (
        <div className="error-message">
          <span className="error-icon">⚠️</span>
          <span>{error}</span>
        </div>
      )}

      {/* Results content */}
      <div className="cron-debug-results">
        {loading ? (
          <div className="loading-container">
            <div className="loader"></div>
            <p className="loading-text">Cargando registros...</p>
          </div>
        ) : apiData && apiData.length > 0 ? (
          <div className="results-list">
            {apiData.map((item, index) => (
              <DataNotificationProcess 
                key={item._id || index} 
                data={item} 
                index={index + (currentPage - 1) * 10}
              />
            ))}
          </div>
        ) : !error && hasSearched && inputPlugin ? (
          <div className="no-results">
            <p>No se encontraron registros para los criterios de búsqueda ingresados</p>
          </div>
        ) : null}
      </div>
    </div>
  );
}

